<template>
	<div class="left">
		<div>
			<energy></energy>
			<Monthlyenergy></Monthlyenergy>
			<devicestatus></devicestatus>
			<!-- <pie></pie> -->
			<!-- <levelindicators></levelindicators> -->
		</div>
	</div>
</template>

<script>
	import energy from './leftchild/energy.vue';
	import Monthlyenergy from './leftchild/Monthlyenergy.vue';
	import devicestatus from './leftchild/devicestatus.vue';
	import levelindicators from './3二级指标部门不合格分布.vue';
	import pie from './pie.vue';
	export default {
	  name: "",
	  components: {
		  energy,
		  Monthlyenergy,
		  devicestatus,
		  levelindicators,
		  pie
	  },
	  methods: {
	   
	  },
	  mounted() {
	     
	  }
	};
</script>

<style scoped="scoped">
	.left{
		position: absolute;
		left: 0;
		top: 0;
		width: 22vw;
		height: 100vh;
		background: url(../../assets/img/left.png) no-repeat;
		background-size: 100% 100%; 
	}
	.left>div{
		position: absolute;
		top: 9.8vh;
		left: 0;
		width: 100%;
		height: 89.6vh;
		/* background: url(../../assets/img/leftchild.png) no-repeat; */
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 3% 12px 3% 16px;
	}
</style> 
